//Library Imports
import React from "react";

//Component Imports
import Header from "../Global/header";
import About from "./about";
import Footer from "../Global/footer";

export default function AboutPage() {
  return (
    <main>
      <Header />
      <About />
      <Footer />
    </main>
  );
}